import { Link } from 'react-router-dom';

export function SWWashingtonHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/c7cbe756131549d4919221c9e2450234.jpg')] bg-cover bg-center opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Used Cars for Southwest Washington — No Dealer Games, No Hidden Fees
          </h1>
          <p className="text-xl sm:text-2xl text-slate-200 mb-8 leading-relaxed">
            We&apos;re right across the bridge in Warrenton, Oregon. Every vehicle is inspected for Pacific Northwest durability — rain, fog, and the occasional Astoria-Megler Bridge wind gust. Transparent pricing, flat $250 doc fee, free delivery to SW Washington.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/inventory"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-car-line text-xl"></i>
              Browse Inventory
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all border border-white/20 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              Talk to a Local
            </Link>
          </div>
          
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-1">$250</div>
              <div className="text-sm text-slate-300">Flat Doc Fee</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-1">Free</div>
              <div className="text-sm text-slate-300">Delivery to SW WA</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-400 mb-1">15 min</div>
              <div className="text-sm text-slate-300">From Longview</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SWWashingtonHero;